export enum FormType {
  Access = "Access Form",
  Attestation = "ATT Form",
}
